<template>
  <div class="add_maintenance_record_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <div>{{ $t('account.name16') }}</div>
    </div>
    <div class="divider"></div>
    <div class="add-content">
      <div class="item-title">
        <div>{{ $t('bike.name278') }}</div>
        <div class="xh">*</div>
      </div>
      <div class="zcbh">
        <el-input v-model="postData.ebikeCode" :placeholder="$t('public.name5')" @input="inputEbikeCode" @blur="blurEbikeCode"></el-input>
        <el-button class="pzsb" type="primary" @click="showScanning(null)">{{ $t('account.name17') }}</el-button>
      </div>
      <div class="item-title" v-if="tenantOptions.length > 1">
        <div>{{ $t('manage.name117') }}</div>
        <div class="xh">*</div>
      </div>
       <div class="zcbh"  v-if="tenantOptions.length > 1">
        <el-select style="width: 100%;" v-model="postData.tenantId" :placeholder="$t('public.name1')" @change="changeDisabled">
    <el-option
      v-for="item in tenantOptions"
      :key="item.tenantId"
      :label="item.tenantName"
      :value="item.tenantId">
    </el-option>
  </el-select>
       </div>
      <div class="item-title">
        <div>{{ $t('bike.name454') }}</div>
        <div class="xh">*</div>
      </div>
      <div class="checkbox-group">
        <el-checkbox-group v-model="checkList" @change="changeCheckBox">
        <el-checkbox :label="item" v-for="(item, index) in maintainTypeList" :key="index">
          {{ item.maintainTypeName }}
        </el-checkbox>
        <!-- <el-checkbox label="控制器"></el-checkbox>
        <el-checkbox label="电机"></el-checkbox>
        <el-checkbox label="电池"></el-checkbox>
        <el-checkbox label="仪表"></el-checkbox>
        <el-checkbox label="轮胎"></el-checkbox>
        <el-checkbox label="其他"></el-checkbox> -->
        <el-input v-model="inputOther" :placeholder="$t('public.name5')"></el-input>
      </el-checkbox-group>
      </div>
      <div v-for="(item, index) in showMaintainTypeList" :key="index">
        <div class="item-title" v-if="item.isShow">
        <div>{{ item.maintainTypeName }}{{ $t('account.name25') }}</div>
        <div class="xh">*</div>
      </div>
      <div class="zcbh" v-if="item.isShow">
        <el-input v-model="item.newPartCode" :placeholder="$t('public.name5')" @input="inputNewPartCode"></el-input>
        <el-button class="pzsb" type="primary" @click="showScanning(item)">{{ $t('account.name17') }}</el-button>
      </div>
      </div>
      <div class="item-title">
        <div>{{ $t('account.name26') }}<span class="limit">{{ $t('account.name27') }}</span></div>
      </div>
      <van-uploader v-model="imgList" multiple :max-count="9" :after-read="handleUpLoadFile" />
      <!-- <el-upload class="avatar-uploader" multiple action :limit="9"  :file-list="postData.fileList"   list-type="picture-card" :http-request="(e) => {handleUpLoadFile(e)}" :show-file-list="false" accept="image/*">
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload> -->
      <el-button type="primary" class="submit-bt" @click="submit" :disabled="disabled" :loading="loading">{{ $t('public.name13') }}</el-button>
    </div>
    <div class="scan" v-if="isScanning">
      <div class="scan-box">
        <div id="scanning" style="width: 100%;"></div>
      </div>
      <span class="close-scan" @click="stopScan">
          <svg t="1681382339822" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2626" width="200" height="200">
            <path d="M512 960c-247.039484 0-448-200.960516-448-448S264.960516 64 512 64 960 264.960516 960 512 759.039484 960 512 960zM512 128.287273c-211.584464 0-383.712727 172.128262-383.712727 383.712727 0 211.551781 172.128262 383.712727 383.712727 383.712727 211.551781 0 383.712727-172.159226 383.712727-383.712727C895.712727 300.415536 723.551781 128.287273 512 128.287273z" fill="#ffffff" p-id="2627"></path>
            <path d="M557.05545 513.376159l138.367639-136.864185c12.576374-12.416396 12.672705-32.671738 0.25631-45.248112s-32.704421-12.672705-45.248112-0.25631l-138.560301 137.024163-136.447897-136.864185c-12.512727-12.512727-32.735385-12.576374-45.248112-0.063647-12.512727 12.480043-12.54369 32.735385-0.063647 45.248112l136.255235 136.671523-137.376804 135.904314c-12.576374 12.447359-12.672705 32.671738-0.25631 45.248112 6.271845 6.335493 14.496116 9.504099 22.751351 9.504099 8.12794 0 16.25588-3.103239 22.496761-9.247789l137.567746-136.064292 138.687596 139.136568c6.240882 6.271845 14.432469 9.407768 22.65674 9.407768 8.191587 0 16.352211-3.135923 22.591372-9.34412 12.512727-12.480043 12.54369-32.704421 0.063647-45.248112L557.05545 513.376159z" fill="#ffffff" p-id="2628"></path>
          </svg>
        </span>
        </div>
  </div>
</template>
<script>
import { wxUploadFile, queryEbikeMaintainTypeList, addEbikeMaintainRecord, queryEbikeTenantList } from '@/api/h5.js'
import { applyMaintainScan } from '@/utils/maintainScanApply'
import { Html5Qrcode } from 'html5-qrcode'
import { getStoredLocale } from '@/config/flavor'
import 'vant-green/lib/index.css'
import Vue from 'vue'
import { Uploader } from 'vant-green'
Vue.use(Uploader)
export default {
  data() {
    return {
      type: '',
      postData: {
        ebikeCode: '',
        tenantId: '',
        partList: [],
        filePathList: []
      },
      tenantOptions: [],
      checkList: [],
      imgList: [],
      maintainTypeList: [],
      showMaintainTypeList: [],
      disabled: true,
      loading: false,
      inputOther: '',
      isScanning: false
    }
  },
  components: {},
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {
    this.getEbikeMaintainTypeList()
  },
  methods: {
    getEbikeMaintainTypeList() {
      const lang = getStoredLocale()
      queryEbikeMaintainTypeList({ lang: lang }).then((res) => {
        if (res.code === 200) {
          this.maintainTypeList = res.data
          this.maintainTypeList.map((item) => {
            if (item.required === 1) {
              const obj = JSON.parse(JSON.stringify(item))
              obj.newPartCode = ''
              obj.isShow = false
              obj.isChecked = false
              this.showMaintainTypeList.push(obj)
            }
          })
        }
      }).catch((res) => {})
    },
    startScan(item) {
      this.isScanning = true
      this.$nextTick(() => {
        this.html5QrCode = new Html5Qrcode('scanning')
        this.html5QrCode
          .start(
            { facingMode: 'environment' },
            { fps: 30, aspectRatio: 1, qrbox: { width: 280, height: 280 } },
            (decodedText, decodedResult) => {
              const apply = applyMaintainScan(this.postData, item, decodedText)
              if (apply.field === 'ebikeCode') {
                this.inputEbikeCode()
              } else {
                this.inputNewPartCode()
              }
              if (apply.refreshTenant) {
                this.blurEbikeCode()
              }
              this.stopScan() // 结束扫码
              // alert('识别结果' + decodedText)
            },
            (errorMessage) => {}
          )
      })
    },
    showScanning(item) {
      Html5Qrcode.getCameras().then(devices => {
        if (devices && devices.length) {
          this.startScan(item)
        }
      }).catch(err => {
        if (typeof window.__wxjs_environment !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
          alert(this.$t('account.name21'))
        } else {
          alert(err)
        }
      })
    },
    stopScan() {
      this.html5QrCode.stop().then(() => {
        this.isScanning = false
      })
    },
    goBack() {
      this.$router.replace({ path: '/home', query: { tab: '2', title: this.$t('tabmenu.name68') } })
    },
    // 统一刷新提交按钮 disabled 状态：所有必填项满足才可提交
    refreshDisabled() {
      this.disabled = true
      const ebikeOk = !!this.postData.ebikeCode
      const tenantOk = !!this.postData.tenantId
      if (!ebikeOk || !tenantOk) return
      // required===1 的维修类型（如 IOT）：选中且配件编号已填才放行
      const requiredShown = this.showMaintainTypeList.filter((item) => item.isShow)
      if (requiredShown.length > 0) {
        this.disabled = !requiredShown.every((item) => !!item.newPartCode)
        return
      }
      // 没有必填配件类型时，只要存在 required===0 的已选类型即可
      const optionalChecked = this.checkList.some((item) => item.required === 0)
      this.disabled = !optionalChecked
    },
    changeCheckBox(e) {
      this.showMaintainTypeList.map((item) => {
        item.isShow = false
        item.isChecked = false
        e.map((items) => {
          if (item.maintainType === items.maintainType) {
            item.isShow = true
            item.isChecked = true
          }
        })
      })
      this.refreshDisabled()
    },
    blurEbikeCode () {
      this.postData.tenantId = ''
      const ebikeCode = this.postData.ebikeCode
      queryEbikeTenantList({ ebikeCode }).then((res) => {
            if (res.code === 200) {
              this.tenantOptions = res.data || []
              if (this.tenantOptions.length === 1) {
                this.postData.tenantId = this.tenantOptions[0].tenantId
              } else if (this.tenantOptions.length === 0 && ebikeCode) {
                // 整车编号不存在或未绑定厂商：明确提示，避免按钮灰掉却无反馈
                this.$message.warning(this.$t('public.name323'))
              }
            }
            this.refreshDisabled()
          }).catch(() => {
            this.refreshDisabled()
          })
    },

     inputEbikeCode() {
      this.refreshDisabled()
    },

    changeDisabled() {
      this.refreshDisabled()
    },
    inputNewPartCode() {
      this.refreshDisabled()
    },
    handleUpLoadFile(param) {
      param.map((item) => {
        const formData = new FormData()
        formData.append('multipart', item.file)
        wxUploadFile(formData)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('public.name42'))
              this.postData.filePathList.push(res.data.objectName)
              item.status = null
            }
          })
          .catch((res) => {})
      })
    },
    submit() {
      this.loading = true
      this.postData.partList = []
      this.showMaintainTypeList.map((item) => {
        if (item.isChecked) {
          this.postData.partList.push(item)
        }
      })
      this.checkList.map((item) => {
        if (item.required === 0) {
          var obj = {}
          if (item.maintainType === '6') {
            obj = {
              maintainType: item.maintainType,
              maintainTypeName: item.maintainTypeName,
              newPartCode: ''
            }
          } else {
            obj = {
              maintainType: item.maintainType,
              maintainTypeName: item.maintainTypeName,
              newPartCode: this.inputOther
            }
          }
          this.postData.partList.push(obj)
        }
      })
      addEbikeMaintainRecord(this.postData).then(res => {
        this.loading = false
        if (res.code === 200) {
          // partial：配件已记、IOT 未换，留在本页便于修正 IOT 编号
          if (res.data && res.data.iotRejected) {
            this.$message.warning(res.data.iotRejectMessage)
            return
          }
          this.$router.replace({ path: '/home', query: { tab: '2', title: this.$t('tabmenu.name68') } })
        }
      }).catch((res) => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss">
.add-content {
  .van-uploader{
    margin-left: -14px;
    margin-top: 10px;
  }
  .el-input__inner {
    height: 50px;
    line-height: 50px;
    border: 0px solid #dcdfe6;
    border-radius: 0px;
    border-bottom: 1px solid #dddee1;
  }
  .el-checkbox__inner {
    width: 24px;
    height: 24px;
  }
  .el-checkbox__inner::after {
    border: 3px solid #fff;
    border-left: 0;
    border-top: 0;
    left: 8px;
    top: 4px;
  }
  .el-checkbox__input{
    line-height: 1.8;
  }
  .el-button {
    border-radius: 100px;
  }
  .el-input__icon {
    display: none;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 15px;
  }
  .el-upload {
    cursor: pointer;
    width: 110px;
    height: 110px;
    background: #eee;
  }
}
.el-loading-mask {
  top: 54px;
  bottom: 0px;
}
</style>

<style lang="scss" scoped>
.add_maintenance_record_container {
  background: #fff;
  width: 100%;
  height: 100%;
  overflow: hidden;
  /* 扫码样式 */
  .scan {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #000;
    z-index: 9999;
    .scan-box {
      width: 100%;
    }
    .close-scan {
      position: absolute;
      top: 20px;
      right: 20px;
      svg {
        width: 40px;
        height: 40px;
      }
    }
  }
  .start-scan{
    position: absolute;
    top: calc(50% - 25px);
    left: calc(50% - 100px);
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 200px;
    height: 50px;
    background: #00aaff;
    color: #fff;
    border-radius: 10px;
  }
  .add-content {
    width: 100%;
    height: calc(100vh - 54px);
    overflow: auto;
    display: flex;
    padding: 15px;
    // margin-left: 15px;
    flex-direction: column;
    .avatar-uploader {
      margin-top: 15px;
      margin-left: -14px;
      width: 110px;
      height: 110px;
    }
    .submit-bt {
      border-radius: 4px;
      margin-top: 85px;
    }
    .checkbox-group{
      margin-top: 10px;
      display: flex;
      flex-direction: row;
    }
    .item-title {
      display: flex;
      flex-direction: row;
      font-size: 15px;
      color: #555;
      margin-top: 15px;
      .limit{
        color: #B9BABB;
      }
      .xh {
        color: #ea4646;
        margin-left: 5px;
      }
    }
    .zcbh {
      width: 100%;
      position: relative;
    }
    .pzsb {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .divider {
    width: 100%;
    height: 10px;
    background: #f6f7fb;
  }

  .top-layout {
    display: flex;
    align-items: center;
    height: 54px;
    .el-icon-arrow-left {
      font-size: 18px;
      font-weight: 600;
      margin-left: 15px;
      cursor: pointer;
      z-index: 10;
    }
    div {
      width: 100%;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
      font-size: 16px;
      font-weight: 800;
      line-height: 28px;
      text-align: center;
      color: #171717;
      z-index: 9;
    }
  }
}
</style>
